/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import VariantParentProductPrice, {
    VariantParentProductPriceStyle,
} from "@eisinc/App/Components/Price/VariantParentProductPrice";
import { CustomAppState } from "@eisinc/App/Store/Reducers";
import { getProductProperties } from "@eisinc/App/Store/Selectors/ProductDetailsSelectors";
import ProductPrice, { ProductPriceStyles } from "@eisinc/Overrides/Components/ProductPrice";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: CustomAppState, ownProps: HasProductContext) => ({
    productSettings: getSettingsCollection(state).productSettings,
    // XNG-Changes
    customSettings: getSettingsCollection(state).customSettings,
    properties: getProductProperties(state, ownProps.productContext?.product),
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
    // XNG-Changes
    wrapper?: InjectableCss;
    variantParentProductPrice?: VariantParentProductPriceStyle;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: { size: 26 },
            unitOfMeasureText: { size: 26 },
        },
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings, customSettings, properties }) => {
    // XNG-Changes: structure changed & Range price added

    return (
        <StyledWrapper {...styles.wrapper}>
            {productContext.product.isVariantParent && (
                <VariantParentProductPrice extendedStyles={styles.variantParentProductPrice} />
            )}
            {!productContext.product.isVariantParent && (
                <ProductPrice
                    product={productContext}
                    showLabel={false}
                    showSavings={true}
                    showSavingsAmount={productSettings.showSavingsAmount}
                    showSavingsPercent={productSettings.showSavingsPercent}
                    extendedStyles={styles.productPrice}
                />
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
